module.exports = __webpack_public_path__ + "img/lens-160-plus-05.6d09a647.png";